export default __webpack_public_path__ + "static/media/slider12.c927b936.JPG";